import Exception from './exception';

export default class ExceptionBlockedUser extends Exception {
  constructor(msg: string | undefined) {
    super(msg);
    Object.setPrototypeOf(this, ExceptionBlockedUser.prototype);
  }
}